import { render, staticRenderFns } from "./FlagHistoryIndex.vue?vue&type=template&id=71f07310&scoped=true&"
import script from "./FlagHistoryIndex.vue?vue&type=script&lang=js&"
export * from "./FlagHistoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./FlagHistoryIndex.vue?vue&type=style&index=0&id=71f07310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f07310",
  null
  
)

export default component.exports